import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import logo from '../../assets/esterCareWorkplaceLogo.svg'
import { OnClickButton } from '../../components/buttons/onclick/OnClickButton'
import { BodyLarge, Title2 } from '../../components/styles/Typography'
import { theme } from '../../theme/theme'

export const PolicyDeclinedPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Page>
      <Box>
        <Logo src={logo} alt="EsterCare" />
        <Title>{t('common.dataPolicy.declinedTitle')}</Title>
        <Body>{t('common.dataPolicy.declinedBody')}</Body>
        <OnClickButton text={t('common.dataPolicy.loginAgain')} onClick={() => navigate('/login')} />
      </Box>
    </Page>
  )
}

const Page = styled.div`
  flex: 1;
  min-width: 0;
  height: 100%;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.mediumLarge}px;
  background: ${theme.color.beigeLight};
`

const Box = styled.div`
  max-width: 560px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const Logo = styled.img`
  height: 18px;
  margin-bottom: ${theme.spacing.large}px;
`

const Title = styled(Title2)`
  margin-bottom: ${theme.spacing.small}px;
  color: ${theme.color.plum};
`

const Body = styled(BodyLarge)`
  margin-bottom: ${theme.spacing.mediumLarge}px;
  font-size: ${theme.fontSize.medium}px;
  line-height: 28px;
  color: ${theme.color.grey5};
`
